function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback, useContext, useMemo } from 'react';
import FormDataChangeContext from '../FormDataChangeWrapper/FormDataChangeContext';
// "_faculty_name" => ["faculty_name"]
// "_intellcont_auth_0_faculty_name" => ["intellcont_auth", "faculty_name"]
function toPathArray(id) {
  return id.split(/\_\d*\_/).map(function (val) {
    return val.indexOf('_') === 0 ? val.substring(1) : val;
  });
}

// screen level: "_faculty_name" => "faculty_name"
// static sub-component: "_name_group_faculty_name" => "name_group_faculty_name"
// dsa: "_intellcont_auth_0_faculty_name" => "intellcont_auth[].faculty_name"
function toTriggerSource(id) {
  var pathParts = toPathArray(id);
  return pathParts.length === 1 ? pathParts[0] : "".concat(pathParts[0], "[].").concat(pathParts[1]);
}

// screen level: "_faculty_name" => { field:"faculty_name" }
// static sub-component: "_name_group_faculty_name" => { key:"name_group", field:"faculty_name" }
// dsa: "_intellcont_auth_0_faculty_name" => { key:"intellcont_auth", index:0, field:"faculty_name" }
function toFormDataLocation(id, triggers) {
  var pathParts = toPathArray(id);
  var result;
  if (pathParts.length > 1) {
    var matchingIds = id.match(/\_\d*\_/);
    var index = matchingIds && matchingIds.length ? matchingIds[0].replace(/\_/g, '') : '';
    result = {
      key: pathParts[0],
      index: index,
      field: pathParts[1]
    };
  } else {
    var pathPart = pathParts[0];
    var triggerSource = '';
    var isSubComponent = triggers.filter(function (trigger) {
      return trigger.sources && trigger.sources.filter(function (source) {
        if (source.indexOf('.') !== -1 && source.replace(/\./, '_') === pathPart) {
          triggerSource = source;
          return true;
        }
      }).length > 0;
    }).length > 0;
    if (isSubComponent) {
      var _subPathParts = triggerSource.split('.');
      result = _subPathParts.length === 1 ? {
        field: pathPart
      } : {
        key: _subPathParts[0],
        field: _subPathParts[1]
      };
    } else {
      result = {
        field: pathParts[0]
      };
    }
  }
  return result;
}

// find all triggers for this field
function getFieldTriggers(id, triggerData) {
  var result = [];
  if (Array.isArray(triggerData)) {
    var fieldTriggerSource = toTriggerSource(id);
    result = triggerData.filter(function (trigger) {
      return trigger.sources && trigger.sources.filter(function (source) {
        var result = source === fieldTriggerSource;
        if (!result && source.indexOf('.') !== -1) {
          result = source.replace(/\./, '_') === fieldTriggerSource;
        }
        return result;
      }).length > 0;
    });
  }
  return result;
}
function isJSONSchema(given) {
  return !!(given && given);
}
function isSiblingInSchema(formDataLocation, potentialSibling, schema) {
  var result = false;
  var properties = schema.properties;
  if (properties) {
    if (typeof formDataLocation.key === 'undefined') {
      result = typeof properties[potentialSibling] !== 'undefined';
    } else if (typeof formDataLocation.index === 'undefined') {
      var rootProperty = properties[formDataLocation.key];
      if (isJSONSchema(rootProperty) && rootProperty.properties) {
        result = typeof rootProperty.properties[potentialSibling] !== 'undefined';
      }
    } else {
      var _rootProperty = properties[formDataLocation.key];
      if (isJSONSchema(_rootProperty) && isJSONSchema(_rootProperty.items) && _rootProperty.items.properties) {
        result = typeof _rootProperty.items.properties[potentialSibling] !== 'undefined';
      }
    }
  }
  return result;
}

// prep triggered data based on value entered
function buildTriggerData(value, triggers, schema, formDataLocation) {
  var result = _defineProperty({}, formDataLocation.field, value);
  triggers.forEach(function (trigger) {
    var triggerDataArray = trigger.data[value];
    if (triggerDataArray) {
      for (var datumIndex = 0; datumIndex < trigger.targets.length; datumIndex++) {
        var targetField = trigger.targets[datumIndex];
        var targetValue = triggerDataArray[datumIndex];
        if (typeof targetValue !== 'undefined' && isSiblingInSchema(formDataLocation, targetField, schema)) {
          result[targetField] = targetValue;
        }
      }
    }
  });
  return result;
}
var getTriggerFieldWidgetWrapper = function getTriggerFieldWidgetWrapper(WrappedComponent, triggerData, triggers) {
  return function (props) {
    var context = useContext(FormDataChangeContext);
    var id = props.id;
    var putFormData = context.putFormData,
      schema = context.schema;
    var handleChange = useCallback(function (value) {
      var formDataLocation = toFormDataLocation(id, triggers);
      schema && putFormData && putFormData({
        data: buildTriggerData(value, triggers, schema, formDataLocation),
        destination: formDataLocation
      });
    }, [id, putFormData, schema, triggers]);
    return /*#__PURE__*/React.createElement(WrappedComponent, Object.assign({}, props, {
      triggerData: triggerData,
      onChange: handleChange
    }));
  };
};
export default function wrapTriggerFieldWidget(WrappedComponent, TriggerSelectComponent, triggerData) {
  if (!triggerData) {
    return WrappedComponent;
  }
  return function (props) {
    var id = props.id;
    var Component = useMemo(function () {
      var triggers = getFieldTriggers(id, triggerData);
      if (!triggers || triggers.length === 0) {
        return WrappedComponent;
      }
      return getTriggerFieldWidgetWrapper(TriggerSelectComponent, triggerData, triggers);
    }, [WrappedComponent, triggerData, id]);
    return /*#__PURE__*/React.createElement(Component, props);
  };
}